// extracted by mini-css-extract-plugin
module.exports = {"container":"_2dHz5x_Ig1-wD9fyHj6AO3"};